import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { OrderDetails } from "../../orders.types";
import { requestGetOrderDetails } from "./getOrderDetails.request";

const useGetOrderDetails = (
  orderId: string,
  options?: QueryOptions<OrderDetails, ApiServiceError<ApiError>>
) => {
  const { data: orderDetails, ...rest } = useQuery({
    queryKey: ["order", "admin", "one", orderId],
    queryFn: async () => await requestGetOrderDetails(String(orderId)),
    enabled: !!orderId,
    cacheTime: 0,
    ...options
  });

  return { orderDetails, ...rest };
};

export default useGetOrderDetails;
